export default __webpack_public_path__ + "static/media/93.4000da30.jpg";